import { getDependencies, createDependenceCompound, deleteCompound } from "../../indexDB/dependencies";
import { getAllQuestion } from "../../indexDB/logic";

/**
 * Obtiene un objeto con las dependencias compuestas
 * @returns {object}
 */
const getCompound = async () => {
    try {
        const result = await getDependencies();
        const { compound } = result;
        return compound;
    } catch (error) {
        console.log("Error: getCompount: ", error);
    }
};
/**
 * Deveulve un objeto con las preguntas hijas.
 * @param {string} nameDad - ID de la pregunta (P_X)
 * @returns { object }
 */
const dataCompound = async nameDad => {
    try {
        const result = await getCompound();
        const objectCompound = result[nameDad];
        return objectCompound;
    } catch (error) {
        console.log("Error: dataCompound: ", dataCompound);
    }
};

/**
 * Formatea el atributo answer dependiendo el tipo de dato de la respuesta, anwert tipo primitivo y answers para los arrays
 * @param {Array} answers - Array de las respuestas del formulario
 * @returns {Array} - Retorna un array de las respuestas del formulario formateadas (answer ó answers)
 */
const formatAnswers = async answers => {
    try {
        const _questions = await getAllQuestion();

        return answers.map(_answer => {
            const question = _questions[_answer.question];
            const property = _answer.hasOwnProperty("answer") ? "answer" : "answers";

            let data = {
                name: question.name,
                [property]: _answer[property],
                type: question.type,
                inputType: question.inputType,
                label: question.label
            };

            if (question.hasOwnProperty("properties")) data.properties = question.properties;
            if (question.hasOwnProperty("options")) data.options = question.options;

            return data;
        });
    } catch (error) {
        console.log("Error: formatAnswers:", error);
    }
};

/**
 * Desvincula una pregunta hija de la relación con el padre
 * @param {string} nameQuestion
 * @param {string} nameChild
 */
const removeCompound = async (nameQuestion, nameChild) => {
    deleteCompound(nameQuestion, nameChild);
};

/**
 * Valida la información de las respuestas y crea la dependencia compuesta
 * @param {string} nameQuestion - ID de la pregunta
 * @param {Array<answers>} data
 * @param {string} type
 */
const saveDependenceCompound = async (nameQuestion, data, type = "AND") => {
    const _cleanData = cleanData(data);
    if (_cleanData.length > 0) {
        const _fixData = fixData(_cleanData);

        const answers = await addIndex(_fixData);

        const related = {
            relatedness: "compound",
            type,
            answers
        };

        createDependenceCompound(nameQuestion, related);
    }
};
/**
 * Filtra las respuestas de las preguntas compuestas para que no se vayan en nulo o vacias.
 * @param {array} data - Array de respuestas para la relación compound
 * @returns { array } - Array de reapuestas validas para la realación compound
 */
const cleanData = data => {
    return data.filter(data => {
        if (data.hasOwnProperty("answer") && data.answer !== null && String(data.answer).length > 0) return true;
        if (data.hasOwnProperty("answers") && data.answers !== null && data.answers.length > 0) return true;
    });
};
/**
 * Recrea la estructura del objeto respuesta para la relación compuesta. verifica si el dato debe llevar las propiedades answer y su relación es múltiple
 * @param {array} data - Array de respuestas para la relación compound
 * @returns { array } -  Array de respuestas para la relación compound
 */
const fixData = data => {
    return data.map(data => {
        let answer = "answer";
        let relatedness = "simple";

        if (data.hasOwnProperty("answers")) {
            answer = "answers";
            relatedness = "multiple";
        }

        return { name: data.name, [answer]: data[answer], relatedness };
    });
};
/**
 * Agreaga los indices de la posición a las preguntas hijas correspondientes a su posición dentro del array del formulario
 * @param { arrray } data - Array de respuestas correspondiente a la dependencia compuesta.
 * @returns { array } - Array de respuestas correspondiente a la dependencia compuesta.
 */
const addIndex = async data => {
    const _questions = await getAllQuestion();
    return data.map(data => {
        const index = _questions.findIndex(item => item.name === data.name);
        return { ...data, question: index };
    });
};

export { getCompound, dataCompound, formatAnswers, saveDependenceCompound, removeCompound };
